export const common = {
  timeChecks: 5 * 60 * 1000,
  cdn: 'https://assets.mosaicai.com.br',
  apiKeyCaptchaV2: '6LcK8TYgAAAAAE4tu19VqOMnWTEx07zXYCFBdt5M',
};
